import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from '../../components/Pagination/Pagination';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { FaPlus } from 'react-icons/fa';
import { API } from 'aws-amplify';

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const CustomProfileList = (props) => {
    const [sites, setSites] = useState([]);
    const [permList, setPermList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    
    // Search state
    const [searchQuery, setSearchQuery] = useState("");

    // Load site
    useEffect(() => {
        const fetchPermission = async () => {
            setIsLoading(true);
            const permission_list = await API.get('custom_permission_list', '/', params);
            setPermList(permission_list);
            setIsLoading(false);
        }

        if (props.user && props.user.user_assets)
            fetchPermission();
    }, [props.user]);

    // NEW: Filter based on search query
    useEffect(() => {
        const handleSearch = () => {
            // If there is a search query, filter by Id, else show all
            const filteredResults = searchQuery 
            ? permList.filter((item) => 
            item.id.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
        : permList;
            setSites(filteredResults);
            paginate(1); // Reset to page 1 after search
        }
        handleSearch();
    }, [searchQuery, permList]);

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItemList = sites.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="DeviceList">
            <div className="col-md-12">
            <div className="row header pb-1 d-flex align-items-center justify-content-between">
            <div>Custom Profiles</div>
            <div style={{ 'marginRight': 'auto', 'marginLeft': '20px' }}> {/* Use flex to push search input left */}
                <input
                    type="text"
                    placeholder="Search by Profile"
                    className="form-control"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} // Update search query state
                />
            </div>
            <div className="d-flex justify-content-end"> {/* Keep button container the same */}
                <Button variant="secondary" onClick={() => { props.history.push('/global_profile/'); }} className="mr-2">
                    Add Permission &nbsp;
                    <FaPlus />
                </Button>
                <Button variant="success" onClick={() => { props.history.push('/new_custom_profile/'); }}>
                    Add Profile &nbsp;
                    <FaPlus />
                </Button>
            </div>
            </div>
            <div className="row">
                <div className="col-md-12 div-content">
                    {(!isLoading) ? (
                        (currentItemList.length === 0) ? (
                            // <div className="col-md-12 p-4 text-center text-secondary">No records found</div>
                            ''
                        ) : (
                            <div>
                                <Table responsive bordered hover variant="light">
                                    <thead>
                                        <tr>
                                            <th className="border-bottom">Id</th>
                                            <th className="border-bottom">Profile</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItemList.map((item, i) => (
                                            <tr key={i} className="table-tr">
                                                <td className="link border-bottom" key="item.id" onClick={() => props.history.push('/profile_det/' + item.id)}>
                                                    {item.id}
                                                </td>
                                                <td className="border-bottom">{item.customProfile.profile_name}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                <Pagination
                                    sizePerPage={itemsPerPage}
                                    currentPage={currentPage}
                                    totalSize={sites.length} // Updated to filtered list size
                                    changeCurrentPage={paginate}
                                    theme="bootstrap"
                                />
                            </div>
                        )) : (
                        <div className="col-md-12">
                            <Spinner animation="grow" size="sm" role="status" variant="warning" />
                            <span className="text-dark">  Loading...</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
        viewPermissions: state.auth.viewPermissions,
    };
};

export default connect(mapStateToProps)(CustomProfileList);
